import { Dt } from "../../../../plugins/datatable";
import {
    getData,
    CSRF,
    bodyRequest,
    requestOptions,
} from "../../../../helpers";

export const comments = () => {
    // console.info("*-*-* comments *-*-*");
    const CurrentSection = document.querySelector(
        "[data-current-section=comments]"
    ); // Identificar la sección
    const TableComments = CurrentSection.querySelector("#dtComments");

    // Start DataTable
    let configDt = {
        processing: true, // Procesar ajax
        serverSide: true, // Mejorar velocidad ajax registros por página
    };

    configDt.ajax = {
        url: getData("#urlDtComments"),
        type: "POST",
        beforeSend: function (request) {
            request.setRequestHeader("X-CSRF-TOKEN", CSRF);
        },
    };
    // Columnas del AJAX
    configDt.columns = [
        { data: "DT_RowIndex", width: "3%", className: "text-center" },
        { data: "date" },
        { data: "name", width: "15%" },
        { data: "comment" },
        { data: "post" },
        {
            data: "public",
            width: "7%",
            className: "text-center",
            orderable: false,
        },
        {
            data: "buttons",
            width: "5%",
            className: "text-center",
            orderable: false,
        },
    ];

    const DtComments = new Dt(configDt);
    DtComments.dataTable("#dtComments");
    // End DataTable
};
